import { InputAdornment, InputLabel, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

export const ProjectJobsUnionFringeForm = ({ formConfig, defaultFormProps, watch, addJobPermisison }) => {
  const isUnion = watch("isUnion");

  const handleKeyDown = e => {
    const allowedKeys = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "." // decimal point
    ];

    // Allow Ctrl/Cmd + A/C/V/X for usability
    if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) {
      return;
    }

    // Prevent non-digit and not in allowed keys
    if (!/\d/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const getFormattedInput = name => {
    // Gate each fringe category through its registered perKey (parity with the prevailing fields).
    const permission = addJobPermisison?.fieldPerObj?.[formConfig[name]?.perKey];
    if (!permission?.canView) return null;
    return (
      <>
        <Controller
          control={defaultFormProps.control}
          name={name}
          rules={formConfig[name].rules}
          render={({ field: { onChange, onBlur, value = "" }, fieldState: { error } }) => (
            <TextField
              onKeyDown={handleKeyDown}
              onChange={e => onChange(e.target.value)}
              onBlur={e => {
                const trimmedValue = e.target.value.trim();
                if (value !== trimmedValue) {
                  onChange(trimmedValue);
                }

                if (typeof onCustomBlur === "function") {
                  onCustomBlur(e);
                }

                onBlur();
              }}
              value={value}
              disabled={!isUnion || !(permission.canEdit || permission.canAdd)}
              variant="outlined"
              fullWidth
              type="number"
              style={{ padding: 0, color: "red" }}
              sx={{
                "& .MuiInputBase-input": {
                  padding: "0"
                }
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                inputProps: {
                  min: 0
                }
              }}
            />
          )}
        />
      </>
    );
  };

  return (
    <>
      <InputLabel style={{ color: "#535353", fontSize: 12, fontFamily: "Poppins", paddingLeft: 5, paddingBottom: 5 }}>
        Fringe Dollar Amount
      </InputLabel>
      <Table style={{ border: "1px solid black" }}>
        <TableHead>
          <TableRow style={{ backgroundColor: "#e3e3e3" }}>
            <TableCell>Health & Welfare (H&W)</TableCell>
            <TableCell>Pension (PENS)</TableCell>
            <TableCell>Annuity (ANN)</TableCell>
            <TableCell>Apprentice Training (APPR)</TableCell>
            <TableCell>Vacation/Sick (VAC)</TableCell>
            <TableCell>Other (OTH)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={{ paddingTop: 8, paddingBottom: 8, border: "none" }}>
              {getFormattedInput("unionStraightTimeFringeHealthAndWelfare")}
            </TableCell>
            <TableCell style={{ paddingTop: 8, paddingBottom: 8, border: "none" }}>{getFormattedInput("unionStraightTimeFringePension")}</TableCell>
            <TableCell style={{ paddingTop: 8, paddingBottom: 8, border: "none" }}>{getFormattedInput("unionStraightTimeFringeAnnuity")}</TableCell>
            <TableCell style={{ paddingTop: 8, paddingBottom: 8, border: "none" }}>
              {getFormattedInput("unionStraightTimeFringeApprenticeTraining")}
            </TableCell>
            <TableCell style={{ paddingTop: 8, paddingBottom: 8, border: "none" }}>{getFormattedInput("unionStraightTimeFringeVacation")}</TableCell>
            <TableCell style={{ paddingTop: 8, paddingBottom: 8, border: "none" }}>{getFormattedInput("unionStraightTimeFringeOther")}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};
